import { useSelector } from "react-redux";
import trans from "../../../utils";
import { Input, InputGroups } from "../../Helpers/Input/Input";

export default function GroupsInfo({ addData }) {
	const inf = useSelector((state) => state.users.user);
	return (
		<>
			<div className="driverinfo mb-24">
				<div className="row">
					<div className="col-lg-6">
						<Input
							title={trans("Name")}
							type="text"
							placeholder={trans("Enter Group Name")}
							formstyle="form-input"
							id="name"
							name="name"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.name}
							touched={addData.touched.name}
							value={addData.values.name || ""}
						/>
					</div>
					<div className="col-lg-6">
						<Input
							title={trans("Code")}
							type="text"
							placeholder={trans("Enter Group Code")}
							formstyle="form-input"
							id="attributes.code"
							name="attributes.code"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.attributes?.code}
							touched={addData.touched.attributes?.code}
							value={addData.values.attributes?.code || ""}
						/>
					</div>
					<div className="col-lg-6">
						<InputGroups
							title={trans("Linked Group")}
							type="text"
							placeholder={trans("Ex. Group 1")}
							formstyle="form-input"
							id="groupId"
							name="groupId"
							onBlur={addData.handleBlur}
							onChange={(value) =>
								addData.setFieldValue("groupId", value ? value : "")
							}
							value={addData.values.groupId || ""}
						/>
					</div>
					<div className="col-lg-6">
						<Input
							title={`${trans("Speed Limit")} (${trans(
								inf.attributes?.speedUnit || "kn"
							)})`}
							type="text"
							placeholder={`${trans("Ex. 10")} ${trans(
								inf.attributes?.speedUnit || "kn"
							)}`}
							formstyle="form-input"
							id="attributes.speedLimit"
							name="attributes.speedLimit"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.attributes?.speedLimit}
							touched={addData.touched.attributes?.speedLimit}
							value={addData.values.attributes?.speedLimit || ""}

						/>
					</div>
					<div className="col-lg-6">
						<Input
							title={`${trans("Fuel Increase Threshold")} (${trans(
								inf.attributes?.volumeUnit || "ltr"
							)})`}
							type="text"
							placeholder={`${trans("Ex. 10")} ${trans(
								inf.attributes?.volumeUnit || "ltr"
							)}`}
							formstyle="form-input"
							id="attributes.fuelIncreaseThreshold"
							name="attributes.fuelIncreaseThreshold"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.attributes?.fuelIncreaseThreshold}
							touched={addData.touched.attributes?.fuelIncreaseThreshold}
							value={addData.values.attributes.fuelIncreaseThreshold || ""}
						/>
					</div>
					<div className="col-lg-6">
						<Input
							title={`${trans("Fuel Drop Threshold")} (${trans(
								inf.attributes?.volumeUnit || "ltr"
							)})`}
							type="text"
							placeholder={`${trans("Ex. 10")} ${trans(
								inf.attributes?.volumeUnit || "ltr"
							)}`}
							formstyle="form-input"
							id="attributes.fuelDropThreshold"
							name="attributes.fuelDropThreshold"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.attributes?.fuelDropThreshold}
							touched={addData.touched.attributes?.fuelDropThreshold}
							value={addData.values.attributes.fuelDropThreshold || ""}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
